/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Nothing_To_CopyInputs */



/**
* | output |
* | --- |
* | "Nothing to copy" |
*
* @param {Spaces_Nothing_To_CopyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_nothing_to_copy = /** @type {((inputs?: Spaces_Nothing_To_CopyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Nothing_To_CopyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nichts zum Kopieren")
	return /** @type {LocalizedString} */ ("Nothing to copy")
});